import React from 'react';
import { AppRouter } from '@/routing/app-router';

export const app: React.FC = () => {
  const AppRouterComponent = AppRouter;
  return <AppRouterComponent />;
};
